
<template>
    <div class="vld-parent">
        <loading :active.sync="activo" :can-cancel="true" :lock-scroll='lockscroll' :color="color" :on-cancel="onCancel" :is-full-page="pagina"></loading>
    </div>
</template>
 
<script>

    import Store from "@/store"
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css'
    
    export default {

        name:'Cargador',

        data() {
            return {
                
                color:'#4b0082',
                transition: 'fade',
                height:50,
                width:50,
                loader:'spinner',//dots bars
                backgroundcolor:'#fff',// es background-color
                opacy: 0.5,
                zindex: 9999, //es z-indez
                enforcefocus: true, //es enforce-focus
                lockscroll:false, //es lock-scroll
                blur:'2px'
                
            }
        },

        components: {
            Loading
        },

        methods: {
            onCancel(){
              alert('El servidor esta demorando un poco, por favor espere!')
            }
        },

        computed:{

          activo(){
            return Store.state.loading
          },
          
          pagina(){
            return Store.state.fullpagina
          }
  
        }
    }
</script>